module.exports = __webpack_public_path__ + "img/Chemistry.254636ef.svg";